import { useGetVehiclesQuery } from "../../../entities/vehicle/api/api.js";
import "react";
import "redux";
import "../../../shared/lib/store/hooks/useAppDispatch.js";
import { useAppSelector } from "../../../shared/lib/store/hooks/useAppSelector.js";
import "../../../shared/lib/store/hooks/useAppStore.js";
import "../../../entities/vehicle/model/selectors/selectVehicleParameters.js";
import "react-redux";
import "../../benefitChoice/model/index.js";
import "../../../shared/lib/store/createAppApi.js";
import "../../../shared/lib/store/createAppAsyncThunk.js";
import "../../../shared/lib/store/createAppSelector.js";
import "../../../shared/lib/store/createAppSlice.js";
import "@perxis-auto/shared";
import "../../../shared/store/config/middleware/index.js";
import "../../../shared/store/config/model/selectors/selectBenefits.js";
import "../../../shared/store/config/model/selectors/selectBooking.js";
import "../../../shared/store/config/model/selectors/selectCredit.js";
import "../../../shared/store/config/model/selectors/selectFilterGrid.js";
import "../../../shared/store/config/model/selectors/selectFilterGridItems.js";
import "../../../shared/store/config/model/selectors/selectFilters.js";
import "../../../shared/store/config/model/selectors/selectGeo.js";
import "../../../shared/store/config/model/selectors/selectGeolocator.js";
import "../../../shared/store/config/model/selectors/selectLocationCollectionIds.js";
import "../../../shared/store/config/model/selectors/selectMaps.js";
import "../../../shared/store/config/model/selectors/selectModels.js";
import "../../../shared/store/config/model/selectors/selectSort.js";
import "../../../shared/store/config/model/selectors/selectTags.js";
import "../../../shared/store/config/model/selectors/selectTradeIn.js";
import "../../../shared/store/config/model/slice.js";
import "../../filterValues/api/api.js";
import "../../filterValues/model/middleware/index.js";
import "../../filterValues/model/selectors/selectAllFilterValues.js";
import "../../filterValues/model/selectors/selectAllFilterValuesParameters.js";
import "../../filterValues/model/selectors/selectAvailableFilterValues.js";
import "../../filterValues/model/selectors/selectAvailableFilterValuesParameters.js";
import "../../filterValues/model/selectors/selectAvailableFilterValuesQueries.js";
import "../../filterValues/model/selectors/selectDependentFilterKeysByKey.js";
import "../../filterValues/model/selectors/selectFilterImmutableQueries.js";
import "../../filterValues/model/selectors/selectFilterImmutableValues.js";
import "../../filterValues/model/selectors/selectFilterItemByKey.js";
import "../../filterValues/model/selectors/selectFilterItems.js";
import "../../filterValues/model/selectors/selectFilterValuesFields.js";
import "../../filterValues/model/selectors/selectGroupedFilterItemByKey.js";
import "../../filterValues/model/selectors/selectIsFilterValuesMissing.js";
import "../../../shared/config/env.js";
import "../../../shared/config/events.js";
import "../../../shared/store/installation/model/slice.js";
import "../../../shared/store/installation/middleware/index.js";
import "../../../entities/vehicle/model/selectors/selectIsVehiclesDataMissing.js";
import "../../../entities/vehicle/model/selectors/selectVehicle.js";
import "../../../entities/vehicle/model/selectors/selectVehicles.js";
import "../../../entities/vehicle/model/selectors/selectVehiclesCount.js";
import "../../../entities/vehicle/model/selectors/selectVehiclesParameters.js";
import "../../../entities/vehicle/model/selectors/selectVehiclesTotalPages.js";
import { selectors } from "../model/index.js";
const useGetFavoriteVehicles = ({ offset }) => {
  const favoriteVehiclesParameters = useAppSelector(
    (state) => selectors.selectFavoriteVehiclesParameters(state, offset)
  );
  const queryResult = useGetVehiclesQuery(favoriteVehiclesParameters);
  return queryResult;
};
export {
  useGetFavoriteVehicles
};
